import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import api from '../services/api';
import type StudyModel from '../models/StudyModel';
import type StudySlideModel from '../models/StudySlideModel';
import Table from './Table';
import CreateStudySlideForm from './CreateStudySlideForm';

type PropTypes = {
    study?: StudyModel;
};

const StudySlides = ({ study }: PropTypes) => {
    const [slides, setSlides] = useState<StudySlideModel[]>([]);
    const [addingSlide, setAddingSlide] = useState(false);
    const [selectedSlide, setSelectedSlide] = useState<
        StudySlideModel | undefined
    >(undefined);

    const pullSlides = async () => {
        const { slides, success } = await api.getStudySlides(study?.id);
        if (success) {
            setSlides(slides);
        }
    };

    useEffect(() => {
        void pullSlides();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const deleteSlide = async (studyId: number, slideId: number) => {
        const success = await api.removeSlideFromStudy(studyId, slideId);
        if (success) {
            setSelectedSlide(undefined);
            void pullSlides();
        }
    };

    const onSlideCreated = () => {
        setAddingSlide(false);
        void pullSlides();
    };

    const columns = ['id', 'study_id', 'study_name', 'slide_id', 'slide'];

    return (
        <div>
            <div className="flex items-center">
                <div className="text-primary text-3xl">Study Slides</div>
                <button
                    type="button"
                    className="btn btn-primary m-4"
                    onClick={async () => {
                        setAddingSlide(true);
                    }}
                >
                    Add Slide To Study
                </button>
            </div>
            <Table
                title="Slides"
                data={slides}
                columns={columns}
                onClick={(slide) => {
                    setSelectedSlide(slide as StudySlideModel);
                }}
            />
            {selectedSlide !== undefined && (
                <Dialog
                    visible={selectedSlide !== undefined}
                    header={`Study Slide ${selectedSlide.id}`}
                    onHide={() => {
                        setSelectedSlide(undefined);
                    }}
                >
                    <p>
                        Are you sure you want to remove Slide{' '}
                        {selectedSlide.slide_id} from Study{' '}
                        {selectedSlide.study_id}?
                    </p>
                    <button
                        type="button"
                        className="btn btn-primary mt-4"
                        onClick={() => {
                            void deleteSlide(
                                selectedSlide.study_id,
                                selectedSlide.slide_id,
                            );
                        }}
                    >
                        Remove Slide From Study
                    </button>
                </Dialog>
            )}
            {addingSlide && (
                <Dialog
                    visible={addingSlide}
                    header="Add Slide To Study"
                    onHide={() => {
                        setAddingSlide(false);
                    }}
                >
                    <CreateStudySlideForm
                        study={study}
                        onSlideCreated={onSlideCreated}
                    />
                </Dialog>
            )}
        </div>
    );
};

export default StudySlides;
